import { render, staticRenderFns } from "./UploadCompleted.vue?vue&type=template&id=53b7a9b2&scoped=true"
import script from "./UploadCompleted.vue?vue&type=script&lang=js"
export * from "./UploadCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b7a9b2",
  null
  
)

export default component.exports